package com.bikompanion.data.cache

import kotlinx.serialization.Serializable

@Serializable
internal data class CachedNetworks(
    val networks: List<CachedNetwork>,
    // Defaults to 0 (maximally stale) so a cache written before this field existed is treated
    // as needing a live refresh, rather than failing to decode.
    val updatedAtEpochMillis: Long = 0L,
)
